var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 33,
    viewBox: "0 0 40 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.5C0 7.66344 7.16344 0.5 16 0.5H24C32.8366 0.5 40 7.66344 40 16.5C40 25.3366 32.8366 32.5 24 32.5H16C7.16344 32.5 0 25.3366 0 16.5Z",
    fill: "#F6F9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 12H14.5",
    stroke: "#FF5A5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15V19",
    stroke: "#FF5A5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 15V19",
    stroke: "#FF5A5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 12V21.5C24.5 21.6326 24.4473 21.7598 24.3536 21.8536C24.2598 21.9473 24.1326 22 24 22H16C15.8674 22 15.7402 21.9473 15.6464 21.8536C15.5527 21.7598 15.5 21.6326 15.5 21.5V12",
    stroke: "#FF5A5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12V11C22.5 10.7348 22.3946 10.4804 22.2071 10.2929C22.0196 10.1054 21.7652 10 21.5 10H18.5C18.2348 10 17.9804 10.1054 17.7929 10.2929C17.6054 10.4804 17.5 10.7348 17.5 11V12",
    stroke: "#FF5A5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c463cc5d874545c9e00c9cc070c9ddf8.svg";
export { ForwardRef as ReactComponent };